import { useState, type ReactNode, type CSSProperties } from 'react'
import { TextIcon } from './TextInspectorIcons'

export const textControl = 'rounded border border-transparent bg-text-editor-control text-text-editor-foreground hover:border-text-editor-hover hover:bg-text-editor-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-text-editor-accent disabled:opacity-40'

export function TextControlRow({ label, children }: { label: string; children: ReactNode }) {
  return <div className="text-control-row"><span>{label}</span><div className="min-w-0">{children}</div></div>
}

export function TextNumber({ label, value, min, max, step = 1, onCommit, suffix }: {
  label: string; value: number; min: number; max: number; step?: number; onCommit: (value: number) => void; suffix?: string
}) {
  const [draft, setDraft] = useState(String(value))
  function commit(next: number) {
    if (!Number.isFinite(next) || next < min || next > max) { setDraft(String(value)); return }
    setDraft(String(next))
    if (next !== value) onCommit(next)
  }
  return <div className="text-number">
    <input aria-label={label} type="number" min={min} max={max} step={step} value={draft}
      onChange={(e) => setDraft(e.target.value)} onBlur={(e) => commit(e.currentTarget.valueAsNumber)}
      onKeyDown={(e) => { if (e.key === 'Enter') e.currentTarget.blur(); if (e.key === 'Escape') { setDraft(String(value)); e.currentTarget.value = String(value); e.currentTarget.blur() } }} />
    {suffix && <span className="pointer-events-none">{suffix}</span>}
    <div className="text-number-stepper">
      <button type="button" tabIndex={-1} aria-label={`${label} +`} onMouseDown={(e) => e.preventDefault()} onClick={() => commit(Number((Number(draft) + step).toFixed(2)))}><TextIcon name="up" /></button>
      <button type="button" tabIndex={-1} aria-label={`${label} −`} onMouseDown={(e) => e.preventDefault()} onClick={() => commit(Number((Number(draft) - step).toFixed(2)))}><TextIcon name="down" /></button>
    </div>
  </div>
}

export function TextRange({ label, value, min, max, step = 1, onCommit }: {
  label: string; value: number; min: number; max: number; step?: number; onCommit: (value: number) => void
}) {
  const [draft, setDraft] = useState(value)
  const rangeStyle: CSSProperties & { '--text-range-progress': string } = { '--text-range-progress': `${(draft - min) / (max - min) * 100}%` }
  return <input className="text-range" type="range" aria-label={label} min={min} max={max} step={step} value={draft}
    style={rangeStyle}
    onChange={(e) => setDraft(e.currentTarget.valueAsNumber)}
    onPointerUp={() => { if (draft !== value) onCommit(draft) }} onKeyUp={() => { if (draft !== value) onCommit(draft) }} />
}
